import { useState } from "react";
import classes from "./PriceRangeSelect.module.scss";
import $ from "utils/selectors";
const InputSelect = ({
  array = [],
  defaultValue,
  setDefaultValue,
  placeHolder,
  maxValue,
  name,
  symbol,
}: {
  array?: any;
  defaultValue?: any;
  setDefaultValue?: (value: any) => void;
  placeHolder?: string;
  maxValue?: any;
  name?: any;
  symbol?: string;
}) => {
  const [dropIt, setDropIt] = useState(false);
  const mapArray = (
    <div className={classes.select_container}>
      {array.map((item, id) => {
        return (
          <div
            className={classes.select_one}
            key={id}
            onClick={() => {
              setDefaultValue(item);
            }}
          >
            <span className={classes.paragraph}>
              {item.toString().replace(/(.)(?=(\d{3})+$)/g, "$1 ")} {symbol}
            </span>
          </div>
        );
      })}
    </div>
  );
  //   useEffect(() => {
  //     if (dropIt) {
  //       $(`#input-select-${name}`).focus();
  //     } else {
  //       $(`#input-select-${name}`).blur();
  //     }
  //   }, [dropIt]);

  return (
    <div className={classes.input_select_container}>
      <div
        id={name}
        className={`${classes.input_container} ${
          dropIt ? classes.input_container_border : ""
        }`}
      >
        <input
          type="text"
          pattern="\d*"
          id={`input-select-${name}`}
          min={0}
          placeholder={placeHolder}
          value={
            defaultValue > 0
              ? defaultValue.toString().replace(/(.)(?=(\d{3})+$)/g, "$1 ")
              : ""
          }
          onChange={(e) => {
            setDefaultValue(
              parseInt(e.target.value.replace(/ /g, "")) > maxValue
                ? maxValue
                : parseInt(e.target.value.replace(/ /g, ""))
            );
          }}
          className={classes.the_input}
          onFocus={() => {
            let id = document.getElementById(name);
            id.style.border = "1px solid #00B4FF";
            id.style.backgroundColor = "white";
            setTimeout(() => {
              setDropIt(true);
            }, 100);
          }}
          onBlur={(e) => {
            let id = document.getElementById(name);
            id.style.border = "none";
            id.style.backgroundColor = "rgba(0, 0, 0, 0.03)";

            setTimeout(() => {
              setDropIt(false);
            }, 200);
          }}
        />
        <div
          onClick={() => {
            if ($(`#input-select-${name}`).is(":focus")) {
              $(`#input-select-${name}`).blur();
            } else {
              $(`#input-select-${name}`).focus();
            }
          }}
          className={classes.flesh_container}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            className={!dropIt ? "" : classes.flip}
          >
            <path
              d="M11 1.5L6 6.5L1 1.5"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      {dropIt ? mapArray : ""}
    </div>
  );
};

export default InputSelect;
